import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpContextToken } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoaderService } from './loader.service';
import { SnackbarService } from './snackbar.service';

export const SHOW_LOADER = new HttpContextToken<boolean>(() => true);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(
    private _snackbarService: SnackbarService,
    private loaderService: LoaderService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let id = '';

    if (request.context.get(SHOW_LOADER)) {
      id = this.loaderService.show();
    }

    const req = request.clone();

    return next.handle(req).pipe(
      finalize(() => {
        this.loaderService.hide(id);
      })
    );
  }
}
